 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"99f8411729c724d8ad71fea8b98031ac379bc661","3":"82759790cb94162bf740399f54e8d8019002b079","4":"2d359d657f593a857b7e0d916f29b2126c86bebb","5":"483661b52a4472adfefdfda9384150c98056bd8b","6":"bc3af440f930e3fea84266ee68f4f21620d52bb3","7":"cf4e168170e58ffd1078d99b4bcbab13220ab7bd","8":"d2b1ca4b1069f7cfc0ac3ccd2306fbb8e76bcf35","9":"08f5b09e92a9f33f93799e273301d7a42014ec3a","10":"0b05f106e7cf0007c072a7be5eff77251a6c1748","11":"15affc4337a6f99f5eacbd148402268e987866f0","12":"2fbfd3663f260eb7b241895b0845dcc690f8d25c","13":"70ab57c681cf0e78e0dd83c5ca5cc56f7a8f16a9","14":"7940f05fe854e1bfe59b8226a5c0cc21b323c732","17":"component---src-pages-404-js","18":"component---src-pages-about-en-js","19":"component---src-pages-about-es-js","20":"component---src-pages-about-fr-js","21":"component---src-pages-about-js","22":"component---src-pages-about-ptbr-js","23":"component---src-pages-about-zh-js","24":"component---src-pages-challenge-en-js","25":"component---src-pages-challenge-es-js","26":"component---src-pages-challenge-fr-js","27":"component---src-pages-challenge-js","28":"component---src-pages-challenge-ptbr-js","29":"component---src-pages-challenge-zh-js","30":"component---src-pages-companies-en-js","31":"component---src-pages-companies-es-js","32":"component---src-pages-companies-fr-js","33":"component---src-pages-companies-js","34":"component---src-pages-companies-ptbr-js","35":"component---src-pages-companies-zh-js","36":"component---src-pages-faq-en-js","37":"component---src-pages-faq-es-js","38":"component---src-pages-faq-fr-js","39":"component---src-pages-faq-js","40":"component---src-pages-faq-ptbr-js","41":"component---src-pages-faq-zh-js","42":"component---src-pages-index-en-js","43":"component---src-pages-index-es-js","44":"component---src-pages-index-fr-js","45":"component---src-pages-index-js","46":"component---src-pages-index-ptbr-js","47":"component---src-pages-index-zh-js","48":"component---src-pages-new-platform-en-js","49":"component---src-pages-new-platform-es-js","50":"component---src-pages-new-platform-fr-js","51":"component---src-pages-new-platform-js","52":"component---src-pages-new-platform-ptbr-js","53":"component---src-pages-new-platform-zh-js","54":"component---src-pages-search-en-js","55":"component---src-pages-search-es-js","56":"component---src-pages-search-fr-js","57":"component---src-pages-search-js","58":"component---src-pages-search-ptbr-js","59":"component---src-pages-search-zh-js","60":"component---src-templates-content-template-js","61":"component---src-templates-part-intro-template-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"7a2e82ae2d38e8ddde9f","2":"cd2ac263a3c461d40a5d","3":"0f93d051e469fd74a3df","4":"3a906e151315cc3758c8","5":"b2cd8780c67ba46d4991","6":"92abb81c972a143147c9","7":"1b9fefe120f214dff3f1","8":"ede3680ab95e4057df23","9":"24dc133e1065a577c8ff","10":"05e0d6d856637d8ac643","11":"35f79520e32a794920a6","12":"df6e78be3983b55dea54","13":"4af8bf97496967cc8d59","14":"cdbb34ba2e3f66ec7f8b","17":"0581400e8e80a9a00483","18":"23e05eb8bd148e66a402","19":"4bd2f4645fc43316e0b2","20":"a3d3002d2d45ea380fdd","21":"282343c12bb0600c7cb2","22":"0c3d4f4104b68b183732","23":"20e15366303be6aba195","24":"890811db8151b73932d8","25":"a992b6c1cd20c83cef18","26":"4189d7dd48afdd074615","27":"a85f1387805c8549f247","28":"0851e471b29c28248286","29":"225a8b98cf2c2b7143d8","30":"0460ecc8559aa633cfa2","31":"acc1a1e0fd34945196f2","32":"fd609641fba27572a3ea","33":"30581206a4fdba6170b0","34":"68d18731f91a469e8eea","35":"177dde317c77ba188150","36":"8b05b624cb69607835a6","37":"d51e8034d54be021da4f","38":"235866b7f123925d815e","39":"9879ec581d8f51a5a153","40":"ed0dc81f12de6c074a44","41":"928ad1976fc9d4d9244a","42":"c1a19004b1c3fba3cff5","43":"c0dcf3f3782633da7f08","44":"3769e97421a0de415933","45":"e0d59bce89a6c31c0c7f","46":"486122363854f33295d5","47":"2e0fa2b9d553a615143f","48":"1b95aeba4e48a95f64f7","49":"335bcb584555abc6216a","50":"f1b1d87f3b20413df2f0","51":"377dc547aec2728480d2","52":"b1c02b4e2a66bced023e","53":"ad8d8163336848e55638","54":"36e7432443f8cd948313","55":"2edc982e02e721330e6e","56":"379a8696e72f390a9a6b","57":"195211711591ba6b2178","58":"f065223adc8f58962b12","59":"e8031039b1c9ee706fd8","60":"8860ef3fdce0a053c949","61":"297371438dc873fdcef6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"99f8411729c724d8ad71fea8b98031ac379bc661","3":"82759790cb94162bf740399f54e8d8019002b079","4":"2d359d657f593a857b7e0d916f29b2126c86bebb","5":"483661b52a4472adfefdfda9384150c98056bd8b","6":"bc3af440f930e3fea84266ee68f4f21620d52bb3","7":"cf4e168170e58ffd1078d99b4bcbab13220ab7bd","8":"d2b1ca4b1069f7cfc0ac3ccd2306fbb8e76bcf35","9":"08f5b09e92a9f33f93799e273301d7a42014ec3a","10":"0b05f106e7cf0007c072a7be5eff77251a6c1748","11":"15affc4337a6f99f5eacbd148402268e987866f0","12":"2fbfd3663f260eb7b241895b0845dcc690f8d25c","13":"70ab57c681cf0e78e0dd83c5ca5cc56f7a8f16a9","14":"7940f05fe854e1bfe59b8226a5c0cc21b323c732","17":"component---src-pages-404-js","18":"component---src-pages-about-en-js","19":"component---src-pages-about-es-js","20":"component---src-pages-about-fr-js","21":"component---src-pages-about-js","22":"component---src-pages-about-ptbr-js","23":"component---src-pages-about-zh-js","24":"component---src-pages-challenge-en-js","25":"component---src-pages-challenge-es-js","26":"component---src-pages-challenge-fr-js","27":"component---src-pages-challenge-js","28":"component---src-pages-challenge-ptbr-js","29":"component---src-pages-challenge-zh-js","30":"component---src-pages-companies-en-js","31":"component---src-pages-companies-es-js","32":"component---src-pages-companies-fr-js","33":"component---src-pages-companies-js","34":"component---src-pages-companies-ptbr-js","35":"component---src-pages-companies-zh-js","36":"component---src-pages-faq-en-js","37":"component---src-pages-faq-es-js","38":"component---src-pages-faq-fr-js","39":"component---src-pages-faq-js","40":"component---src-pages-faq-ptbr-js","41":"component---src-pages-faq-zh-js","42":"component---src-pages-index-en-js","43":"component---src-pages-index-es-js","44":"component---src-pages-index-fr-js","45":"component---src-pages-index-js","46":"component---src-pages-index-ptbr-js","47":"component---src-pages-index-zh-js","48":"component---src-pages-new-platform-en-js","49":"component---src-pages-new-platform-es-js","50":"component---src-pages-new-platform-fr-js","51":"component---src-pages-new-platform-js","52":"component---src-pages-new-platform-ptbr-js","53":"component---src-pages-new-platform-zh-js","54":"component---src-pages-search-en-js","55":"component---src-pages-search-es-js","56":"component---src-pages-search-fr-js","57":"component---src-pages-search-js","58":"component---src-pages-search-ptbr-js","59":"component---src-pages-search-zh-js","60":"component---src-templates-content-template-js","61":"component---src-templates-part-intro-template-js"}[chunkId]||chunkId) + "." + {"0":"3e230e2fb85940e0080d","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
